// extracted by mini-css-extract-plugin
export default {"background":"Home_background__w4mTu","line-clamp":"Home_line-clamp__2yKcZ","line-clamp-3":"Home_line-clamp-3__3x4Qu"};